import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import Prompt from '../interfaces/Prompt';

@Injectable({
  providedIn: 'root'
})
export class PromptService {
  prompt = {
    hidden: true,
    heading: '',
    body: '',
    confirmText: '',
    rejectText: '',
  }
  userResponse = new BehaviorSubject('');
  prompt$ = new BehaviorSubject(this.prompt);

  constructor() {}

  setPrompt(p: Prompt) {
    this.prompt = {...p}
    this.prompt$.next(this.prompt);
  }
  setResponse(response) {
    this.userResponse.next(response);
  }
  clearPrompt() {
    this.prompt = {
      hidden: true,
      heading: '',
      body: '',
      confirmText: '',
      rejectText: '',
    }
    this.prompt$.next(this.prompt);
    this.userResponse.next('')
  }
}
